import { createHash } from "crypto";

const getProjectHash = (schemaPath: string): string => {
  return createHash("sha256").update(schemaPath).digest("hex").substring(0, 8);
};

export default getProjectHash;
